import { Item } from "../Data";


export const WISHLIST_SERVICE_URLS = {
    GET_WISHLIST: 'wishlists',
    PUT_ITEM_TO_WISHLIST: 'wishlists',
    DELETE_FROM_WISHLIST: 'wishlists'
};

export interface GetWishListResponse {
    totalCount: number;
    items: Item[];
}
